<template>
    <b-modal @hide="resolve(false)" size="lg" hide-footer ref="errorModal" :title="title">
        <div v-if="messages.length > 0" class="error-modal__body">
            <div class="text-danger body-title">Info messages</div>
            <div v-for="(message, index) in messages" :key="index">
                <span>{{message}}</span>
            </div>
        </div>
        <div class="error-modal__controls text-right">
            <button class="btn btn-primary" @click.prevent="close"> Close </button>
        </div>
    </b-modal>
</template>

<script>
export default {
  name: 'ErrorModal',
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    messages: [],
    title: ''
  }),
  methods: {
    open ({ title, data }) {
      this.dialog = true
      this.title = title
      this.messages = [...data]
      this.$refs['errorModal'].show()
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    close () {
      this.dialog = false
      this.resolve(false)
      this.$refs['errorModal'].hide()
    }
  }
}
</script>

<style lang="scss" scoped>
    .error-modal__body{
        max-height: 400px;
        overflow-y: auto;
        font-size: 16px;
        .body-title{
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 10px;
        }
    }
</style>
